import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.5 18.5C18.5 19.2956 18.1839 20.0587 17.6213 20.6213C17.0587 21.1839 16.2956 21.5 15.5 21.5H8.5C7.70435 21.5 6.94129 21.1839 6.37868 20.6213C5.81607 20.0587 5.5 19.2956 5.5 18.5V6.5H4.5V3.5H9L10 2.5H14L15 3.5H19.5V6.5H18.5V18.5ZM6.5 6.5V18.5C6.5 19.0304 6.71071 19.5391 7.08579 19.9142C7.46086 20.2893 7.96957 20.5 8.5 20.5H15.5C16.0304 20.5 16.5391 20.2893 16.9142 19.9142C17.2893 19.5391 17.5 19.0304 17.5 18.5V6.5H6.5ZM18.5 5.5V4.5H14.5L13.5 3.5H10.5L9.5 4.5H5.5V5.5H18.5ZM8.5 8.5H9.5V18.5H8.5V8.5ZM14.5 8.5H15.5V18.5H14.5V8.5Z",
      fill: "black"
    }, null, -1)
  ]))]))
}